import React, { useState, useEffect } from 'react';
import { ArrowRight, Calendar } from 'lucide-react';
import axios from 'axios';
import OptimizedImage from './OptimizedImage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const LatestNews = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${API}/pages?page_type=news&published_only=true&limit=6`);
        const data = Array.isArray(response.data) ? response.data : response.data.pages || [];
        setPosts(data.slice(0, 6));
      } catch (error) {
        console.error('Error fetching latest news:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  if (loading || posts.length === 0) return null;

  return (
    <section className="py-20 bg-gradient-to-b from-black via-gray-900 to-black" data-testid="latest-news-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            <span className="bg-gradient-to-r from-red-500 via-yellow-400 to-red-500 bg-clip-text text-transparent">
              Aktuelt
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Siste nytt fra verkstedet — tips, nyheter og faglig oppdateringer
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {posts.map((post) => (
            <a
              key={post.id || post.slug}
              href={`/aktuelt/${post.slug}`}
              className="group block bg-gray-800/40 border border-gray-700/50 rounded-xl overflow-hidden hover:border-red-600/40 transition-all duration-300 hover:shadow-lg hover:shadow-red-900/10"
              data-testid={`news-card-${post.slug}`}
            >
              {post.featured_image && (
                <div className="h-44 overflow-hidden">
                  <OptimizedImage
                    src={post.featured_image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              )}
              <div className="p-5">
                <div className="flex items-center text-xs text-gray-500 mb-3">
                  <Calendar className="w-3.5 h-3.5 mr-1.5" />
                  {new Date(post.published_date || post.created_at).toLocaleDateString('no-NO', {
                    day: 'numeric', month: 'short', year: 'numeric'
                  })}
                </div>
                <h3 className="text-white font-semibold mb-2 group-hover:text-red-400 transition-colors line-clamp-2">
                  {post.title}
                </h3>
                {post.excerpt && (
                  <p className="text-gray-400 text-sm line-clamp-2">{post.excerpt}</p>
                )}
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/aktuelt"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-white/5 border border-white/10 rounded-lg hover:bg-white/10 hover:border-red-600/40 transition-all"
            data-testid="view-all-news-link"
          >
            Se alle artikler
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
